<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="fetch">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
      </div>
    </customize-page>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import taxSubAccountApi from "@/api/taxSubAccountApi";
import authApi from "@/api/auth";
import { mapGetters } from "vuex";

export default {
  components: {
    CustomizePage
  },
  mixins: [Page],
  created() {
    authApi.getOmsUserInfo().then(res => {
      this.userInfo = res;
      this.fetch();
    });
  },
  data() {
    return {
      userInfo: {},
      loading: false,
      dataList: [],
      columns: [
        {
          title: "货主id",
          key: "accountNid",
          align: "center",
          width: 160
        },
        {
          title: "担保企业",
          key: "enterpriseName",
          align: "center",
          "min-width": 160
        },
        {
          title: "充值金额",
          key: "rechargeAmount",
          align: "center",
          "min-width": 150,
          render: (h, params) => {
            let rechargeAmount = params.row.rechargeAmount;
            if (rechargeAmount == null) {
              return <div>0.00</div>;
            }
            let r = (parseInt(rechargeAmount) / 100).toFixed(2);
            return <div>{r}</div>;
          }
        },
        {
          title: "消费金额",
          width: 150,
          key: "expenseAmount",
          align: "center",
          render: (h, param) => {
            let expenseAmount = param.row.expenseAmount;
            if (expenseAmount == null) {
              return <div>0.00</div>;
            }
            return <div>{(parseInt(expenseAmount) / 100).toFixed(2)}</div>;
          }
        },
        {
          title: "税金余额",
          "min-width": 150,
          key: "taxBalance",
          align: "center",
          render: (h, param) => {
            let taxBalance = param.row.taxBalance;
            if (taxBalance == null) {
              return <div>0.00</div>;
            }
            return <div>{(parseInt(taxBalance) / 100).toFixed(2)}</div>;
          }
        }
      ],
      filterObj: {
        // portNid: "NCPORT"
      },
      currentRow: [],
      sortObj: {}
    };
  },
  computed: {
    ...mapGetters({
      getCustomerList: "getCustomerList"
    })
  },
  methods: {
    fetch(data) {
      this.loading = true;
      const filterParams = this.getFilterParams();

      const sortObj = data ? data : this.sortObj;
      if (this.userInfo.customerId) {
        filterParams.accountNid = this.userInfo.customerId;
      }
      taxSubAccountApi
        .pageQuery({
          ...sortObj,
          request: {
            ...filterParams,
            pageIndex: this.pagination.currentPage,
            pageSize: this.pagination.pageSize
          }
        })
        .then(res => {
          this.loading = false;
          this.dataList = res.taxSubAccountEntities || [];
          const pageInfo = res.pageInfo || { totalCount: 0 };
          this.pagination = { ...this.pagination, ...pageInfo };
        })
        .catch(error => {
          this.$message.error(error.msg || "未知错误");
        });
    },
    selectionChange(row) {
      this.currentRow = row;
    },
    getFormConfig() {
      const type = this.getFormItemType();
      const customerIdCondition = [];
      if (!this.userInfo.customerId) {
        customerIdCondition.push({
          label: "货主id",
          value: this.userInfo.customerId,
          model: "accountNid",
          type: type.SELECT,
          props: {
            data: this.getCustomerList
          }
        });
      }
      return [
        {
          data: [...customerIdCondition]
        }
      ];
    }
  }
};
</script>
